// extracted by mini-css-extract-plugin
export default {"pager":"pager__2roil"};